import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { map } from 'rxjs';
import { Playlist } from '../models/playlist';

@Injectable({
  providedIn: 'root'
})
export class PlaylistsService {

  http = inject(HttpClient);

  getPlaylists() {
    return this.http
      .get<ApiResponse<Playlist[]>>(`${environment.apiUrl}/playlists`)
      .pipe(map(response => response.data));

  }
}